import React, { Fragment } from 'react';
import { TableCell } from '@material-ui/core';
import moment from 'moment';
import '../Table.css';

// cell contains Day of the Week and Month-Day below
const WeekDateCells = ({ weekDates }) => {
  return (
    <Fragment>
      { weekDates.map((date, index) => (
        <TableCell key={index} style={{ paddingLeft: 16, paddingRight: 16 }}>
          <div>
            <p className='row-label'>{moment(date).format('dddd')}</p>
            <p className='row-sub-label'>{moment(date).format('MMM D')}</p>
          </div>
        </TableCell>
      ))}
    </Fragment>
  );
};

export default WeekDateCells;
